import React from 'react'
import Header from './Header'
import Footer from './Footer'
import useLocalStorage from 'use-local-storage'

const Settings = () => {
  const [theme, setTheme] = useLocalStorage('theme', 'light');
  const [offlineStorage, setOfflineStorage] = useLocalStorage('offline', true);
  const [notify, setNotify] = useLocalStorage('notify', false);

  const switchTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme)
  }

  const switchStorage = () => {
    const newSetting = offlineStorage === true ? false : true;
    setOfflineStorage(newSetting)
  }

  const switchNotify = () => {
    const newSetting = notify === true ? false : true;
    setNotify(newSetting)
  }

  return (
    <div className="all-pages-bg">
      <Header style={'mini'} />
      <div className="list-content">
        <div className="list-info">
          <h5>Settings</h5>
          <p>Personalize your experience here</p>

          <div className="settings-item">        
            <input 
              type="checkbox"
              name="darkMode"
              id="darkMode"
              className="toggle"
              checked={theme === 'dark' ? true : false}
              onChange={switchTheme}
            >
            </input>
            <label htmlFor="darkMode" className="toggleLabel">Theme</label>
            <p>Enable DarkMode theme</p>
          </div>

          <div className="settings-item">        
            <input 
              type="checkbox"
              name="offlineStorage"
              id="offlineStorage"
              className="toggle"
              checked={offlineStorage}
              onChange={switchStorage}
            >
            </input>
            <label htmlFor="offlineStorage" className="toggleLabel">Offline Storage</label>
            <p>Enable offline storage</p>
          </div>

          <div className="settings-item">        
            <input 
              type="checkbox"
              name="notifications"
              id="notifications"
              className="toggle"
              checked={notify}
              onChange={switchNotify}
            >
            </input>
            <label htmlFor="notifications" className="toggleLabel">Notifications</label>
            <p>Enable notifications</p>
          </div>

        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Settings